import { store } from 'store';

import { SupportAtHomeFundingTypes } from '~constants/maps';

import { getQuarterEndDate } from '~libs/dayjs';

import { getAll as getClientContributions } from '~support-at-home/actions/clientContributions';
import { getAll as getClientServices } from '~support-at-home/actions/clientServices';
import { getAll as getPricePlans } from '~support-at-home/actions/pricePlans';
import { getAll as getSahBudgets } from '~support-at-home/actions/sahBudgets';

import { clear as clearPricePlanRevisions } from '~support-at-home/reducers/pricePlanRevisions';
import { clear as clearPricePlans } from '~support-at-home/reducers/pricePlans';

const clearPlans = () => {
  store.dispatch(clearPricePlans([]));
  store.dispatch(clearPricePlanRevisions([]));
};

export const onChangeStartDate: (values: any) => any = async ({ start_date, end_date }) => {
  clearPlans();

  if (start_date && !end_date) {
    const end_date = getQuarterEndDate(start_date);
    return { end_date, package_fixed_id: null, client_id: null };
  }
};

export const onChangeClient: (values: any) => any = async ({ client_id, start_date, end_date }) => {
  const state = store.getState();
  const { clients } = state.main;
  const client = clients.rows.find(({ id }) => parseInt(client_id) === id);

  const resetValues = {
    price_plan_id: '',
    price_plan_revision_id: '',
    package_fixed_id: null,
    total_amount: '',
    total_includes_case_management: null,
  };

  if (!client) {
    clearPlans();
    return resetValues;
  }

  // Await API responses for form dependencies
  await Promise.all([
    store.dispatch(getPricePlans({ start_date: { lte: start_date }, end_date: { gte: end_date } })),
    store.dispatch(getSahBudgets({ client_id })),
    store.dispatch(getClientContributions({ client_id })),
    store.dispatch(getClientServices({ client_id })),
  ]);

  return resetValues;
};

export const onChangeSahBudgets: (values: any) => any = async ({ client_sah_budget_id, package_fixed_id }) => {
  const state = store.getState();
  const { sahBudgets } = state.supportAtHome;
  const sahBudget = sahBudgets.rows.find(({ id }) => client_sah_budget_id === id);

  if (!sahBudget) {
    // SAH budget cleared — restore package-appropriate CM default
    const { clientPackageSchedules } = state.main;
    const packageSchedule = clientPackageSchedules.rows.find(
      ({ package: { id } }) => Number(package_fixed_id) === id,
    );
    const isQuarterly =
      packageSchedule?.package?.funding_type?.sah_code === SupportAtHomeFundingTypes.SAH_QUARTERLY_CLIENT;
    return { total_amount: 0, total_includes_case_management: isQuarterly ? false : null };
  }

  return { total_amount: sahBudget.total_amount, total_includes_case_management: false };
};

export const onChangePackageSchedule: (values: any) => any = async ({ package_fixed_id, client_id }) => {
  const { clientPackageSchedules } = store.getState().main;

  const packageSchedule = clientPackageSchedules.rows.find(
    ({ package: { id } }) => Number(package_fixed_id) === id && Number(client_id) === client_id,
  );

  const isQuarterly =
    packageSchedule?.package?.funding_type?.sah_code === SupportAtHomeFundingTypes.SAH_QUARTERLY_CLIENT;
  return { total_includes_case_management: isQuarterly ? false : null };
};
